import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import rgba from 'assets/theme/function/rgba';
import borders from 'assets/theme/base/borders';

const { action } = colors;

const listItemButton = {
    styleOverrides: {
        root: {
            justifyContent: 'center',
            paddingTop: pxToRem(15),
            paddingBottom: pxToRem(15),
            //paddingRight: pxToRem(0),
            //paddingLeft: pxToRem(0),

            '&:hover': {
                backgroundColor: rgba(colors.secondary.dark, 1),
                borderRadius: borders.borderRadius.md,
            },

            '&.Mui-selected': {
                backgroundColor: rgba(colors.primary.main, 0.1),
                borderRadius: borders.borderRadius.md,
                color: action.selectedIcon,

                '& svg': {
                    fill: action.selectedIcon,
                },

                '&:hover': {
                    backgroundColor: rgba(colors.primary.main, 0.1),
                    borderRadius: borders.borderRadius.md,
                },
            },

            '&.MuiTouchRipple-root': {
                backgroundColor: 'transparent',
            },
        },
    },
};

export default listItemButton;
